import { loyaltyBenefits } from '@/mocks/promos';
import { useScrollReveal, useStaggerReveal } from '@/hooks/useScrollReveal';

const PromoLoyalty = () => {
  const { ref: sectionRef, isVisible } = useScrollReveal({ threshold: 0.1 });
  const { containerRef: cardsRef, visibleItems } = useStaggerReveal(loyaltyBenefits.length, { threshold: 0.05 });

  return (
    <section className="px-6 lg:px-12 pb-20">
      <div className="max-w-7xl mx-auto">
        <div
          ref={sectionRef as React.RefObject<HTMLDivElement>}
          className="rounded-2xl overflow-hidden relative"
          style={{
            background: 'linear-gradient(135deg, rgba(255,45,120,0.08) 0%, rgba(0,245,255,0.06) 50%, rgba(57,255,20,0.06) 100%)',
            border: '1px solid rgba(255,45,120,0.2)',
            opacity: isVisible ? 1 : 0,
            transform: isVisible ? 'translateY(0)' : 'translateY(36px)',
            transition: 'opacity 0.7s cubic-bezier(0.22,1,0.36,1), transform 0.7s cubic-bezier(0.22,1,0.36,1)',
          }}
        >
          {/* Glow blobs */}
          <div className="absolute top-0 left-0 w-64 h-64 rounded-full opacity-10" style={{ background: '#ff2d78', filter: 'blur(80px)' }} />
          <div className="absolute bottom-0 right-0 w-64 h-64 rounded-full opacity-10" style={{ background: '#00f5ff', filter: 'blur(80px)' }} />

          <div className="relative z-10 p-8 md:p-12">
            <div className="text-center mb-10">
              <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full mb-4" style={{ background: 'rgba(255,45,120,0.1)', border: '1px solid rgba(255,45,120,0.3)' }}>
                <i className="ri-vip-crown-line text-sm" style={{ color: '#ff2d78' }} />
                <span className="font-mono text-xs tracking-wider" style={{ color: '#ff2d78' }}>ПРОГРАММА ЛОЯЛЬНОСТИ</span>
              </div>
              <h2 className="font-orbitron font-black text-3xl md:text-4xl text-white mb-3">
                БОНУСНАЯ ПРОГРАММА<br />
                <span style={{ color: '#f0ff00', textShadow: '0 0 20px #f0ff0060' }}>NEONPHARMA</span>
              </h2>
              <p className="font-mono text-sm text-white/40 max-w-lg mx-auto">
                Копите баллы с каждой покупки и получайте эксклюзивные скидки. 1 балл = 1 рубль.
              </p>
            </div>

            <div
              ref={cardsRef as React.RefObject<HTMLDivElement>}
              className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-10"
            >
              {loyaltyBenefits.map((b, i) => (
                <div
                  key={b.title}
                  className="flex flex-col items-center text-center p-5 rounded-2xl transition-all duration-300 group"
                  style={{
                    background: `${b.color}08`,
                    border: `1px solid ${b.color}20`,
                    opacity: visibleItems[i] ? 1 : 0,
                    transform: visibleItems[i] ? 'translateY(0) scale(1)' : 'translateY(20px) scale(0.95)',
                    transition: 'opacity 0.5s cubic-bezier(0.22,1,0.36,1), transform 0.5s cubic-bezier(0.22,1,0.36,1)',
                  }}
                >
                  <div
                    className="w-12 h-12 flex items-center justify-center rounded-xl mb-3"
                    style={{ background: `${b.color}15`, border: `1px solid ${b.color}40` }}
                  >
                    <i className={`${b.icon} text-xl`} style={{ color: b.color, textShadow: `0 0 10px ${b.color}` }} />
                  </div>
                  <h3 className="font-orbitron font-bold text-sm mb-1" style={{ color: b.color }}>{b.title}</h3>
                  <p className="font-mono text-xs text-white/40 leading-relaxed">{b.desc}</p>
                </div>
              ))}
            </div>

            {/* CTA */}
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <button
                className="whitespace-nowrap px-8 py-3.5 rounded-full font-orbitron font-bold text-sm tracking-widest cursor-pointer transition-all"
                style={{ background: '#ff2d78', color: '#fff', boxShadow: '0 0 20px rgba(255,45,120,0.5)' }}
              >
                ЗАРЕГИСТРИРОВАТЬСЯ
              </button>
              <button
                className="whitespace-nowrap px-8 py-3.5 rounded-full font-orbitron font-bold text-sm tracking-widest cursor-pointer transition-all"
                style={{ border: '1px solid rgba(255,255,255,0.15)', color: 'rgba(255,255,255,0.6)' }}
              >
                УЗНАТЬ ПОДРОБНЕЕ
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PromoLoyalty;
